import { Box, Button, Center, Heading, HStack, Text } from '@chakra-ui/react';
import { getCourierCode, getCourierName } from '../lib/util/courier';

interface IProgressInfo {
  status: number;
}
function ProgressInfo(props: IProgressInfo) {
  const getInfoTitle = (iStatus: number) => {
    switch (iStatus) {
      case 1:
        return '접수하신 제품을 선불 택배로 보내주세요';
      case 2:
        return '제품이 센터로 이동중입니다.';
      default:
        return '';
    }
  };
  console.log(getCourierCode('CJ대한통운'));
  return (
    <Box mt={'36px'} mb={'20px'} px={'20px'}>
      <Heading fontSize={'16px'} fontWeight="semibold">
        진행내용
      </Heading>
      <Center
        w={'full'}
        h={'40px'}
        mt={'16px'}
        bg={'#eeeeee'}
        borderRadius={'base'}>
        <Text fontSize={'14px'} fontWeight="semibold" color={'#191600'}>
          {getInfoTitle(props.status)}
        </Text>
      </Center>
      {props.status === 1 && (
        <Box>
          <HStack mt={'20px'}>
            <Text
              w={'64px'}
              fontSize={'14px'}
              fontWeight="medium"
              color={'#191600'}>
              이름
            </Text>
            <Text fontSize={'14px'} fontWeight="semibold" color={'##000'}>
              {'코스모앤컴퍼니 AS센터'}
            </Text>
          </HStack>
          <HStack mt={'0px'}>
            <Text
              w={'64px'}
              fontSize={'14px'}
              fontWeight="medium"
              color={'#191600'}>
              연락처
            </Text>
            <Text fontSize={'14px'} fontWeight="semibold" color={'#000'}>
              {'2938-4858-3958'}
            </Text>
          </HStack>
          <HStack mt={'0px'}>
            <Text
              w={'64px'}
              fontSize={'14px'}
              fontWeight="medium"
              color={'#191600'}>
              주소
            </Text>
            <Text fontSize={'14px'} fontWeight="semibold" color={'#000'}>
              {'경기도 고양시 일산동구 장진천길134번길 25'}
            </Text>
          </HStack>
          <Text fontSize={'13px'} color={'#4697f7'} mt={'12px'}>
            {'발송비용은 고객 부담이오니 반드시 선불 발송해주세요.'}
          </Text>
        </Box>
      )}
      {props.status === 7 && (
        <Box>
          <HStack mt={'20px'} spacing={'24px'} pos={'relative'}>
            <Text fontSize={'14px'} fontWeight="medium" color={'#191600'}>
              택배사
            </Text>
            <Text fontSize={'14px'} fontWeight="semibold" color={'##000'}>
              {'CJ 대한통운'}
            </Text>
            <Button
              position={'absolute'}
              right={0}
              colorScheme={'black_button'}
              w="51px"
              h={'23px'}
              borderRadius={'base'}
              fontSize={'9px'}
              fontWeight="medium"
              onClick={async () => {
                var option =
                  'resizable=yes, width = 500, height = 1000, top = 100, left = 200, location = no';
                window.open('about:blank', 'invoiceWin', option);
                var f = document.getElementById(
                  'invoiceForm'
                ) as HTMLFormElement;
                var keyField = document.getElementById('t_key');
                keyField?.setAttribute('value', 'KovnpwxG1gaVmBNrMCIm4w');
                var codeField = document.getElementById('t_code');
                codeField?.setAttribute('value', getCourierCode('CJ대한통운'));
                var invoiceField = document.getElementById('t_invoice');
                invoiceField?.setAttribute('value', '6892028779587');
                f?.submit();
              }}>
              배송조회
            </Button>
          </HStack>
          <HStack mt={'0px'} spacing={'24px'}>
            <Text fontSize={'14px'} fontWeight="medium" color={'#191600'}>
              운송장
            </Text>
            <Text fontSize={'14px'} fontWeight="semibold" color={'#000'}>
              {'2938-4858-3958'}
            </Text>
          </HStack>
        </Box>
      )}
    </Box>
  );
}
export default ProgressInfo;
